import React, { useMemo } from 'react';
import { PaginationStyles as S } from './Pagination.styles';
import useMedia from '@hooks/useMedia';
import Arrow from '@img/icons/arrow_left.svg';
import { withMotion } from '@hoc/withMotion';
import { Device, until } from '@helpers/media';
const Pagination = ({ pages, currentPage, onChange }) => {
    const itemLimit = useMedia([until(Device.TabletLarge)], [4], 5);
    const items = useMemo(() => {
        let _items = [];
        if (pages > itemLimit) {
            // Trigger the '...' functionality //
            if (currentPage > 1) {
                if (currentPage + (itemLimit - 2) >= pages) {
                    for (let i = Math.max(currentPage - (itemLimit - (pages - currentPage) - 1), 1); i <= pages; i++) {
                        _items.push(i);
                    }
                }
                else {
                    if (itemLimit === 5) {
                        _items = [Math.max(currentPage - 1, 1), currentPage, currentPage + 1, -1, pages];
                    }
                    else {
                        _items = [Math.max(currentPage - 1, 1), currentPage, -1, pages];
                    }
                }
            }
            else {
                if (itemLimit === 5) {
                    _items = [currentPage, currentPage + 1, currentPage + 2, -1, pages];
                }
                else {
                    _items = [currentPage, currentPage + 1, -1, pages];
                }
            }
        }
        else {
            for (let i = 1; i <= pages; i++) {
                _items.push(i);
            }
        }
        return _items;
    }, [pages, currentPage, itemLimit]);
    return (React.createElement(S.Container, null,
        React.createElement(S.ArrowContainer, { direction: "left", "data-disabled": currentPage === 1, onClick: (e) => e.currentTarget.dataset.disabled !== 'true' && onChange(currentPage - 1), type: "button" },
            React.createElement(Arrow, null)),
        React.createElement(S.HexagonContainer, null, items.map((item, i) => (React.createElement(S.Hexagon, { onClick: () => item > 0 && onChange(item), center: pages === 1, active: currentPage === item, key: `Pagination_${i}`, type: "button" },
            React.createElement("span", null, item < 0 ? '...' : item))))),
        React.createElement(S.ArrowContainer, { direction: "right", "data-disabled": currentPage === pages, onClick: (e) => e.currentTarget.dataset.disabled !== 'true' && onChange(currentPage + 1), type: "button" },
            React.createElement(Arrow, null))));
};
export default withMotion(Pagination);
